export default __webpack_public_path__ + "static/media/suggestion-chips-lex2.0ed218c0.png";